import React, { Component } from "react";

class Dashbaord extends Component {
 render() {
    return (
      <div>
        Dashbaord
      </div>
    );
  }
}

export default Dashbaord;
